export default {
  "slug": "pull-station-placement",
  "title": "Manual Pull Station Placement Basics",
  "description": "Where to place manual fire alarm pull stations: near exits, the right mounting height for accessibility, and travel-distance spacing so occupants always reach one.",
  "keywords": "manual pull station placement, fire alarm pull station height, pull station location, fire alarm training",
  "ogImage": "/guide-og/pull-station-placement.jpg",
  "faqs": [
    {
      "q": "Where should manual pull stations be located?",
      "a": "Pull stations are generally placed near each exit and at exit stairways so occupants pass one on the way out, plus additional stations so no one has to travel too far to reach one."
    },
    {
      "q": "What height should a pull station be mounted at?",
      "a": "Mounting height must be reachable by all occupants, including people using wheelchairs. Follow the accessibility range in your adopted code and accessibility standard for the exact dimensions."
    },
    {
      "q": "How far apart do pull stations need to be?",
      "a": "Additional stations are added along large floors so occupants never exceed the maximum travel distance to reach one. Confirm that maximum distance in your adopted code edition."
    }
  ],
  "category": "Design",
  "readMins": 4,
  "published": "2026-09-27",
  "updated": "2026-09-27",
  "hero": "/guide-hero/pull-station-placement.jpg",
  "heroAlt": "Illustration of a manual fire alarm pull station mounted beside an exit door",
  "excerpt": "A manual pull station only helps if occupants can find and reach it. Here's how placement, height, and spacing work in plain language.",
  "sections": [
    {
      "h": "What a manual pull station does",
      "p": "A manual pull station lets an occupant start the fire alarm by hand. It's an initiating device, normally positioned so anyone leaving can activate the alarm as they evacuate."
    },
    {
      "h": "Where to place them",
      "p": "Pull stations are generally located near each exit and at exit stairway doors, so occupants pass one on the natural path out of the building on every floor."
    },
    {
      "h": "Mounting height and accessibility",
      "p": "Height matters for accessibility — a pull station must be within a reachable range for all occupants, including those using wheelchairs. Use the range in the adopted code and accessibility standard."
    },
    {
      "h": "Travel distance and spacing",
      "p": "So occupants never have to walk too far, extra pull stations are added across large floors. Verify the maximum allowed travel distance in your adopted code edition."
    }
  ],
  "relatedModules": [
    "design-principles",
    "installation",
    "basics"
  ],
  "relatedGuides": [
    "fire-alarm-system-design-basics",
    "fire-alarm-wiring-and-circuits"
  ]
};
